import { AxiosResponse } from "axios";
import { useDispatch } from "react-redux";
import * as React from 'react';
import { finishLoading, startLoading } from "../../store/reducers/Loading";
import { handleError } from "./handleError";

export function useBackgroundPromiseEffectByCondition<T>(
  condition: () => boolean,
  call: () => Promise<AxiosResponse<T>>,
  afterCall: (x: T) => void,
  dependencies: React.DependencyList,
  disableAnimation?: boolean
) {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  React.useEffect(() => {
    let cancelled = false;
    let response: AxiosResponse<T> | undefined;

    const sendRequest = async () => {
      if (!condition()) return;
      try {
        if (!disableAnimation) dispatch(startLoading);
        setIsLoading(true);
        response = await call();
      } catch (err) {
        handleError(err, dispatch);
      } finally {
        if (!disableAnimation) dispatch(finishLoading);
        setIsLoading(false);
      }
      if (!cancelled && response !== undefined) {
        if (response.status === 200) {
          afterCall(response.data);
        }
      }
    };

    sendRequest();
    return () => { cancelled = true; };
    // eslint-disable-next-line
  }, dependencies);

  return isLoading;
}
